import React, { Component } from "react";
import { Grid } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import {
  get_YMD_from_SYS,
  isValidItem,
  get_30DaysBack_FromCurrentDate,
} from "../SystemUtility/SystemUtility";
import { fetchOrder, fetchSales } from "./API";
import TableList from "./CustomTool/TableList";

class OrderSelection extends Component {
  state = {
    LedgerNameList: [],
    CustomerList: [],
    StoreNameList: [],
    LoadingSrNo: [],
    autoEnableDisalbe_Col_Info: [],
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(new Date()),
      dtpToDate: get_YMD_from_SYS(new Date()),
      cmbResPerson: "All",
      cmbCustomer: "All",
      cmbOutwardStore: "",
    },
    columns: [
      { id: "Action", label: "", name: "SelectOrder" },
      { id: "vac_orderitemno", label: "Order No." },
      { id: "dat_orderdateDMY", label: "Order Date" },
      { id: "vac_customer", label: "Customer" },
      { id: "vac_itemname", label: "Item Name" },
      { id: "vac_unit", label: "Packing" },
      { id: "pendingqty", label: "Pending Qty" },
      { id: "vac_ledgername", label: "Delivery Responsible Person" },
    ],
    actionList: [
      {
        name: "SelectOrder",
        icon: "", //<CheckBoxOutlineBlankIcon color="primary" />,
        link: "OrderSelection:",
        actionType: "Chk",
      },
    ],
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    dataLoadStatus: true,
    DisableCmb: false,
    edit_salessrno: 0,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Order Selection";
    this.props.setActiveMenu("OrderSelection");
    this.onFormLoad();
    // this.setSearchColumns();
  }

  isSelectionFromLoading = () => {
    if (this.props.SelectionFrom === "Loading") {
      return true;
    } else if (this.props.SelectionFrom === "Sales") {
      return false;
    } else {
      return false;
    }
  };
  //#endregion Component

  onFormLoad = () => {
    if (this.isSelectionFromLoading()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        let reqData = {
          Op: "OrderSelection",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          BolLoadCmbWithAll: true,
        };
        fetchOrder(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            let LedgerNameList = res.data.LedgerNameList,
              CustomerList = res.data.CustomerList,
              StoreNameList = res.data.StoreList;
            this.setState(
              {
                dataLoadStatus: true,
                LedgerNameList,
                StoreNameList,
                CustomerList,
              },
              () => {}
            );
          })
          .catch((error) => {
            this.props.toastMsg(
              "error",
              "Unkonwn Error occured in onFormLoad. " + error
            );
          });
      });
    } else {
      this.setState({ DisableCmb: true });
    }
    document.getElementById("dtpFromDate").focus();
  };

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnNewEntryClick = () => {
    this.props.navigateTo("VehicleLoadEntry");
  };

  handleOnChangeAutoEnableDisalbe_ColIdxs = (autoEnableDisalbe_Col_Info) => {
    this.setState({ autoEnableDisalbe_Col_Info });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion Handle

  validateLoadEntry = () => {
    let result = false;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Select From Date ", "dtpFromDate");
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Select To Date ", "dtpToDate");
    } else if (this.state.formData.cmbResPerson.length <= 0) {
      this.props.toastErrorMsg(
        "Select Delivery Responsible Person",
        "cmbResPerson"
      );
    } else if (
      !isValidItem(
        this.state.LedgerNameList,
        "vac_ledgername",
        this.state.formData.cmbResPerson
      )
    ) {
      this.props.toastErrorMsg(
        "Select Valid Delivery Responsible Person",
        "cmbResPerson"
      );
    } else if (this.state.formData.cmbCustomer.length <= 0) {
      this.props.toastErrorMsg("Select Customer Name", "cmbCustomer");
    } else if (
      !isValidItem(
        this.state.CustomerList,
        "vac_customer",
        this.state.formData.cmbCustomer
      )
    ) {
      this.props.toastErrorMsg("Select Valid Customer Name", "cmbCustomer");
    } else if (this.state.formData.cmbOutwardStore.length <= 0) {
      this.props.toastErrorMsg("Select Outward Store", "cmbOutwardStore");
    } else if (
      !isValidItem(
        this.state.StoreNameList,
        "vac_storename",
        this.state.formData.cmbOutwardStore
      )
    ) {
      this.props.toastErrorMsg("Select Valid Outward Store", "cmbOutwardStore");
    } else if (
      this.state.formData.cmbOutwardStore === this.props.vac_storename
    ) {
      this.props.toastErrorMsg(
        "Outward store and loading store can't be same",
        "cmbResPerson"
      );
    } else {
      result = true;
    }
    return result;
  };

  validateCheckBox = () => {
    for (let i = 0; i < this.state.rows.length; i++) {
      if (this.state.rows[i].Action !== undefined) {
        if (this.state.rows[i].Action === true) {
          return true;
        }
      }
    }
    this.props.toastErrorMsg("Check At Least One CheckBox", "SelectOrder");
    return false;
  };

  validateSales = () => {
    let result = false;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Select From Date ", "dtpFromDate");
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Select To Date ", "dtpToDate");
    } else {
      result = true;
    }
    return result;
  };

  Load = () => {
    if (this.isSelectionFromLoading()) {
      if (this.validateLoadEntry()) {
        this.props.notifyProcessing();
        let dataLoadStatus = false;
        this.setState({ dataLoadStatus }, () => {
          let reqData = {
            Op: "OrderSelectionData",
            bint_acyear: localStorage.getItem("ACY"),
            bint_acid: localStorage.getItem("acid"),
            SelectionFrom: "Loading",
            dat_fromdate: this.state.formData.dtpFromDate,
            dat_todate: this.state.formData.dtpToDate,
            vac_drp: this.state.formData.cmbResPerson,
            vac_customer: this.state.formData.cmbCustomer,
          };
          fetchOrder(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let rows = res.data.ItemDataForLoading,
                rowsCount = rows.length;
              this.setState({
                dataLoadStatus: true,
                rows,
                rowsCount,
              });
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        });
      }
    } else {
      // console.log("faizan");
      if (this.validateSales()) {
        this.props.notifyProcessing();
        // this.setState({ DisableCmb: true });
        let dataLoadStatus = false;
        this.setState({ dataLoadStatus }, () => {
          let reqData = {
            Op: "OrderSelectionData",
            bint_acyear: localStorage.getItem("ACY"),
            bint_acid: localStorage.getItem("acid"),
            SelectionFrom: "Sales",
            dat_fromdate: this.state.formData.dtpFromDate,
            dat_todate: this.state.formData.dtpToDate,
            vac_drp: this.props.DRPname,
            vac_customer: this.props.Customer,
          };
          fetchOrder(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let rows = this.assignDec_loadqtyTOPendingQty(
                  res.data.ItemDataForSales
                ),
                rowsCount = rows.length;
              this.setState(
                {
                  dataLoadStatus: true,
                  rows,
                  rowsCount,
                },
                () => {}
              );
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        });
      }
    }
  };

  assignDec_loadqtyTOPendingQty = (rows) => {
    let newRows = rows.map((row, index) => {
      if (row.pendingqty === undefined && row.dec_loadqty) {
        // console.log("index,row", index, row);
        row["pendingqty"] = Number(row.dec_loadqty);
      }
      return row;
    });
    return newRows;
  };

  Process = () => {
    if (this.isSelectionFromLoading()) {
      if (this.validateLoadEntry() && this.validateCheckBox()) {
        let Checkrows = [];
        this.state.rows.filter((row) => {
          if (row.Action === true) {
            Checkrows.push({
              vac_orderitemno: row.vac_orderitemno,
              loadingqty: row.dec_qty,
            });
          }
        });
        this.props.notifyProcessing();
        let dataLoadStatus = false;
        this.setState({ dataLoadStatus }, () => {
          let reqData = {
            Op: "OrderSelectionProcess",
            bint_acyear: localStorage.getItem("ACY"),
            bint_acid: localStorage.getItem("acid"),
            SelectionFrom: "Loading",
            vac_company: localStorage.getItem("CompanyName"),
            bint_loadingsrno: this.props.bint_loadingsrno,
            dat_loaddate: this.props.dat_loaddate,
            vac_loadingstore: this.props.vac_storename,
            vac_groupname: this.props.vac_groupname,
            vac_ledgername: this.props.vac_ledgername,
            vac_outwardstore: this.state.formData.cmbOutwardStore,
            ItemData: Checkrows,
          };
          fetchOrder(reqData)
            .then(
              (res) => {
                this.props.updateProcessing(res.data.msgType, res.data.message);
                if (res.data.msgType === "success") {
                  this.props.onSuccessfulOrderSelection(res.data.ItemData);
                } else {
                  this.setState({
                    dataLoadStatus: true,
                  });
                }
              },
              () => {}
            )
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        });
      }
    } else {
      if (this.validateSales() && this.validateCheckBox()) {
        // console.log("validation completed of else");
        // alert("validation completed of else");
        let Checkrows = [];
        this.state.rows.filter((row) => {
          if (row.Action === true) {
            Checkrows.push({
              vac_orderitemno: row.vac_orderitemno,
              vac_loadingitemno: row.vac_loadingitemno,
              dec_qty: row.dec_loadqty,
            });
          }
        });
        this.props.notifyProcessing();
        let dataLoadStatus = false;
        this.setState({ dataLoadStatus }, () => {
          let reqData = {
            Op: "SaveSales_Item",
            bint_acyear: this.props.bint_acyear,
            bolinvoiceprint: false,
            bint_acid: this.props.bint_acid,
            vac_company: this.props.cmbCompany,
            bint_salessrno: this.props.bint_salessrno,
            dat_salesdate: this.props.dtpDate,
            vac_billtype: this.props.cmbBillType,
            vac_billno: this.props.txtBillNo,
            bint_billno: this.props.bint_billno,
            vac_customer: this.props.cmbCustomer,
            vac_customershipto: this.props.cmbShipTo,
            vac_referencename: this.props.cmbReference,
            dec_discamt: this.props.txtDiscount,
            dec_taxable: this.props.txtTaxable,
            dec_cgst: this.props.txtCGST,
            dec_sgst: this.props.txtSGST,
            dec_igst: this.props.txtIGST,
            dec_grtotal: this.props.txtGrandTotal,
            dec_tdsamount: this.props.txtTDSAmount,
            dec_advancepayment: this.props.txtAdvPayment,
            dec_roundoff: this.props.txtRoundOff,
            dec_netpayment: this.props.txtNetPayment,
            vac_salestransactiontype: this.props.cmbTransactionType,
            bint_vouno: 0,
            vac_remark: this.props.txtRemark,
            vac_receiptgenerated: this.props.vac_receiptgenerated,
            vac_referencename: this.props.vac_referencename,
            bint_ci: this.props.bint_ci,
            vac_username: this.props.vac_username,
            OrderData: Checkrows,
            SalesItemData: [],
            PaymentData: [],
            OtherDetailData: [],
          };
          fetchSales(reqData)
            .then((res) => {
              // console.log("#1: Res Received");
              this.props.updateProcessing(res.data.msgType, res.data.message);
              if (res.data.msgType === "success") {
                // console.log("#2: Res Success");
                try {
                  // console.log("#3: Res try started");
                  let dec_basicamt = 0,
                    dec_disamt = 0,
                    dec_taxable = 0,
                    dec_cgstamt = 0,
                    dec_sgstamt = 0,
                    dec_igstamt = 0,
                    dec_totalamt = 0,
                    SalesItemData = [],
                    bint_salessrno = 0;
                  SalesItemData = res.data.SalesItemData;
                  this.props.onSuccessfulSelsSelection(res.data.SalesItemData);
                  // console.log("#4: DisableEdit called");
                  if (res.data.SalesList) {
                    // console.log("#5: res.data.SalesList found");
                    bint_salessrno = res.data.SalesList[0].bint_salessrno;
                    // console.log(
                    //   "res.data.SalesList[0].bint_salessrno",
                    //   res.data.SalesList[0].bint_salessrno
                    // );
                  }
                  if (res.data.TotalItemAmountData) {
                    // console.log("#6: res.data.TotalItemAmountData found");
                    dec_basicamt = Number(
                      res.data.TotalItemAmountData[0].dec_basicamt
                    );
                    dec_disamt = Number(
                      res.data.TotalItemAmountData[0].dec_disamt
                    );
                    dec_taxable = Number(
                      res.data.TotalItemAmountData[0].dec_taxable
                    );
                    dec_cgstamt = Number(
                      res.data.TotalItemAmountData[0].dec_cgstamt
                    );
                    dec_sgstamt = Number(
                      res.data.TotalItemAmountData[0].dec_sgstamt
                    );
                    dec_igstamt = Number(
                      res.data.TotalItemAmountData[0].dec_igstamt
                    );
                    dec_totalamt = Number(
                      res.data.TotalItemAmountData[0].dec_totalamt
                    );
                    console.log(
                      "dec_taxable,dec_cgstamt,dec_sgstamt,dec_igstamt,dec_totalamt,dec_disamt,bint_salessrno",
                      dec_taxable,
                      dec_cgstamt,
                      dec_sgstamt,
                      dec_igstamt,
                      dec_totalamt,
                      dec_disamt,
                      bint_salessrno
                    );
                  }
                  // console.log("bint_salessrno before set", bint_salessrno);
                  // console.log(
                  //   "#7: Going to execute edit_salessrno=bint_salesrno in sst"
                  // );
                  this.props.resetAmount(
                    dec_taxable,
                    dec_cgstamt,
                    dec_sgstamt,
                    dec_igstamt,
                    dec_totalamt,
                    dec_disamt,
                    bint_salessrno
                  );
                  this.props.refreshSalesItemList(
                    SalesItemData,
                    SalesItemData.length
                  );
                } catch (error) {
                  console.log(error);
                  alert("error occurred");
                }
              } else {
                this.setState({
                  dataLoadStatus: true,
                });
              }
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        });
      }
    }
  };

  render() {
    // console.log("this.props.DRPname", this.props.DRPname);
    // console.log("this.state.dataLoadStatus", this.state.dataLoadStatus);
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Order Selection</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtDtp
              id="dtpFromDate"
              defaultValue={this.state.formData.dtpFromDate}
              label="From Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpToDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              defaultValue={this.state.formData.dtpToDate}
              label="To Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbResPerson"
            />
          </Grid>
          <Grid
            item
            display={this.state.DisableCmb === true ? "none" : "block"}
          >
            <CtCmbEditable
              id="cmbResPerson"
              label="Delivery Responsible Person*"
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              items={this.state.LedgerNameList}
              value={this.state.formData.cmbResPerson}
              colID="vac_ledgername"
              width={300}
              maxLength={100}
              nextCtrlID="cmbCustomer"
            />
          </Grid>
          <Grid
            item
            display={this.state.DisableCmb === true ? "none" : "block"}
          >
            <CtCmbEditable
              id="cmbCustomer"
              label="Customer*"
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              items={this.state.CustomerList}
              value={this.state.formData.cmbCustomer}
              colID="vac_customer"
              width={200}
              maxLength={100}
              nextCtrlID="cmbOutwardStore"
            />
          </Grid>
          <Grid
            item
            display={this.state.DisableCmb === true ? "none" : "block"}
          >
            <CtCmbEditable
              id="cmbOutwardStore"
              label="Outward Store*"
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              items={this.state.StoreNameList}
              value={this.state.formData.cmbOutwardStore}
              colID="vac_storename"
              width={200}
              maxLength={100}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn label="Load" onClick={this.Load} />
          </Grid>
          <Grid item>
            <CtBtn label="Process" onClick={this.Process} />
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          headRowFontColor="#ffffff"
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnRowDataChange={this.handleOnRowDataChange}
          // handleOnChangeAutoEnableDisalbe_ColIdxs={this.handleOnChangeAutoEnableDisalbe_ColIdxs}
          // provideSearch={true}
          // handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Vehicle Load Entry"
        />
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(OrderSelection))));
